import { useDesktopView } from 'utils/hooks/useDesktopView'

/**
 * Controls whether the desktop responsive layout is active for /bcks pages.
 *
 * Driven by the Toggle SDK key 'bcks-desktop-view-enabled'.
 * - false (default): always renders mobile layout
 * - true: uses actual viewport -- desktop layout activates at >=768px
 */
export const useBCKSDesktopView = () =>
  useDesktopView('bcks-desktop-view-enabled')
